import React from "react";
import MaskedFormControl from 'react-bootstrap-maskedinput';

const InputMaskForm = (props)=>{
    return (
        <MaskedFormControl 
            type='text' 
            name={props.id} 
            id={props.id}
            value={props.value} 
            disabled={props.disabled} 
            required={props.required}
            onChange={(e)=>props.handleChange(e, props.variables)} 
            onKeyPress={(e)=>props.validate(e, props.variables)}
            mask={props.mask}
            placeholder={props.placeholder}
            className={"form-control input-date"+props.class} 
        />
    )
}

export default InputMaskForm;

InputMaskForm.defaultProps = {
    disabled:false,
    required:false,
    mask:'11/11/1111',
    placeholder:'DD/MM/YYYY',
    validate:()=>{},
    variables:'',
    class:''
}